import React, { useState } from "react";
import Weather from '../image/weather_app.png';
import Pomodoro from '../image/tomato_timer.png';
import MyCurly from '../image/myCurly.png';
import Right from '../image/arrow.svg';
import ResponsiveNav from '../components/ResponsiveNav';
import Nav from '../components/Nav';
import WavingSVG from '../components/waveSvg/WavingSvg';
import webDesign from '../image/web_design.mov'
import AutoPlayVideo from '../components/AutoPlayVideo';

const Project = () => {

  const [currentBoxIndex, setCurrentBoxIndex] = useState(0);

  const position = currentBoxIndex * -250;

  const slideLeft = () => {
    if (currentBoxIndex > 0) {
      setCurrentBoxIndex(currentBoxIndex - 2);
    }
  };

  const slideRight = () => {
    if (currentBoxIndex < 3) {
      setCurrentBoxIndex(currentBoxIndex + 4);
    }
  };

  return (
    <div id='project_container' className='flex flex-col lg:flex-row gap-10 w-full font-[Vintage]'>
      <Nav />
      <ResponsiveNav />
    <div className="relative w-full h-full overflow-hidden flex flex-col gap-10">
      <p className='text-center text-2xl font-bold text-[#29819a] pt-10'>Some Of My Projects</p>
      <p className='text-center text-lg px-6 lg:px-[20%]'>
        Discover my captivating projects! Dive into a world of creativity, innovation, and problem-solving.
        Explore my portfolio and witness the results of my passion and dedication.
      </p>
      {/* small size screen (mobile and tab) */}
      <div
        className="flex lg:hidden flex-wrap items-center justify-center gap-20  w-full h-auto p-10"
      >
        <div className='flex flex-col gap-10 w-[90%] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-4'>
          <div className='flex justify-between items-center px-5'>
            <p className='p-2 font-semibold text-[#29819a]'>MYCurly</p>
            <a href='https://mycurly.netlify.app/' className='flex gap-1 hover:text-[#29819a] hover:underline cursor-pointer' target="_blank" rel="noreferrer"><img src={Right} className='w-5 h-5' alt='right arrow'/> Live </a>
          </div>
          <img src={MyCurly} className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500' alt='weather app screenshot' />
          <div className='flex flex-col justify-between px-4 gap-4'>
            <p className='text-justify text-base p-4'>
              MyCurly app built for local hairdressers and curly hair products. Powered by React and Tailwind CSS, with OAuth for secure authorization and authentication. Deployed on Netlify.
            </p>
            
          </div>
        </div>
        <div className='flex flex-col gap-10 w-[90%] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-4'>
            <p className='p-2 font-semibold text-[#29819a]'>Web Design</p>
            <AutoPlayVideo
            src={webDesign}
            alt="Your fallback content" 
            className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500'
            />
            <div className='flex flex-col justify-between'>
              <p className='text-justify text-base p-4'>
               My web design, crafted in Figma, boasts simplicity and adaptability. It's not only responsive across various devices, but also includes interactive animations to enhance the user experience.
              </p>
            </div>
          </div>
         <div className='flex flex-col gap-10 w-[90%] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-4'>
            <div className='flex justify-between items-center px-5'>
              <p className='p-2 font-semibold text-[#29819a]'>Pomodoro Timer</p>
              <a href='https://pomodoro-timer-todolist.netlify.app/' className='flex gap-1 hover:text-[#29819a] hover:underline cursor-pointer' target="_blank" rel="noreferrer"><img src={Right} className='w-5 h-5' alt='right arrow'/> Live </a>
            </div>
            <img src={Pomodoro} className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500' alt='pomodoro screenshot' />
            <div className='flex flex-col justify-between px-4 gap-4'>
              <p className='text-justify text-base p-4'>
                Pomodoro Timer app built with React and Tailwind CSS, deployed on Netlify. It features a 30-minute timer, a to-do list, and integrates with Spotify for background music while working.
              </p>
            </div>
          </div>
          <div className='flex flex-col gap-10 w-[90%] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-4'>
            <div className='flex justify-between items-center px-5'>
              <p className='p-2 font-semibold text-[#29819a]'>Weather App</p>
              <a href='https://weather-app-based-on-city.netlify.app/' className='flex gap-1 hover:text-[#29819a] hover:underline cursor-pointer' target="_blank" rel="noreferrer"><img src={Right} className='w-5 h-5' alt='right arrow'/> Live </a>
            </div>
            <img src={Weather} className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500' alt='weather app screenshot' />
            <div className='flex flex-col justify-between px-4 gap-4'>
              <p className='text-justify text-base p-4'>
                Weather app built with HTML, CSS, JavaScript, and Bootstrap, using a free API. It allows users to search for weather information by city name and provides a 5-day forecast with a graph. The app is deployed on Netlify for easy access.
              </p>
            </div>
          </div>
      </div>
      {/* large size screen */}
      <div
        className="hidden lg:flex items-center gap-32 transition-transform duration-1000 w-fit h-fit px-20"
        style={{ transform: `translateX(${position}px)` }}
      >
        <div className='flex flex-col gap-6 w-[100%] h-fit md:w-[60%] lg:w-[400px] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-2'>
          <div className='flex justify-between items-center px-5'>
            <p className='p-2 font-semibold text-[#29819a]'>MYCurly</p>
            <a href='https://mycurly.netlify.app/' className='flex gap-1 hover:text-[#29819a] hover:underline cursor-pointer' target="_blank" rel="noreferrer"><img src={Right} className='w-5 h-5' alt='right arrow'/> Live </a>
          </div>
          <img src={MyCurly} className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500' alt='weather app screenshot' />
          <div className='flex flex-col justify-between px-4 gap-4'>
            <p className='text-justify text-base'>
              MyCurly app built for local hairdressers and curly hair products. Powered by React and Tailwind CSS, with OAuth for secure authorization and authentication. Deployed on Netlify.
            </p>
            
          </div>
        </div>
        <div className='flex flex-col gap-6 w-[100%] h-fit md:w-[60%] lg:w-[400px] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-2'>
            <p className='p-2 font-semibold text-[#29819a]'>Web Design</p>
            <AutoPlayVideo
            src={webDesign}
            alt="Your fallback content" 
            className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500'
            />
            <div className='flex flex-col justify-between'>
              <p className='text-justify text-base'>
               My web design, crafted in Figma, boasts simplicity and adaptability. It's not only responsive across various devices, but also includes interactive animations to enhance the user experience.
              </p>
            </div>
          </div>
         <div className='flex flex-col gap-6 w-[100%] h-fit md:w-[60%] lg:w-[400px] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-2'>
            <div className='flex justify-between items-center px-5'>
              <p className='p-2 font-semibold text-[#29819a]'>Pomodoro Timer</p>
              <a href='https://pomodoro-timer-todolist.netlify.app/' className='flex gap-1 hover:text-[#29819a] hover:underline cursor-pointer' target="_blank" rel="noreferrer"><img src={Right} className='w-5 h-5' alt='right arrow'/> Live </a>
            </div>
            <img src={Pomodoro} className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500' alt='pomodoro screenshot' />
            <div className='flex flex-col justify-between px-4 gap-4'>
              <p className='text-justify text-base'>
                Pomodoro Timer app built with React and Tailwind CSS, deployed on Netlify. It features a 30-minute timer, a to-do list, and integrates with Spotify for background music while working.
              </p>
            </div>
          </div>
          <div className='flex flex-col gap-6 w-[100%] h-fit md:w-[60%] lg:w-[400px] outline-double outline-offset-2 outline-4 outline-[#29819a] rounded p-2'>
            <div className='flex justify-between items-center px-5'>
              <p className='p-2 font-semibold text-[#29819a]'>Weather App</p>
              <a href='https://weather-app-based-on-city.netlify.app/' className='flex gap-1 hover:text-[#29819a] hover:underline cursor-pointer' target="_blank" rel="noreferrer"><img src={Right} className='w-5 h-5' alt='right arrow'/> Live </a>
            </div>
            <img src={Weather} className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500' alt='weather app screenshot' />
            <div className='flex flex-col justify-between px-4 gap-4'>
              <p className='text-justify text-base'>
                Weather app built with HTML, CSS, JavaScript, and Bootstrap, using a free API. It allows users to search for weather information by city name and provides a 5-day forecast with a graph. The app is deployed on Netlify for easy access.
              </p>
            </div>
          </div>
      </div>
      <button
        className="hidden lg:flex absolute top-2/3 left-10 transform -translate-y-1/2 p-2  bg-gray-700 text-[#29819a] text-3xl font-extrabold rounded-md"
        onClick={slideLeft}
      >
        &#8249;
      </button>
      <button
        className="hidden lg:flex absolute top-2/3 right-10 transform -translate-y-1/2 p-2 bg-gray-700 text-[#29819a] text-3xl font-extrabold rounded-md"
        onClick={slideRight}
      >
        &#8250;
      </button>
    </div>
      <WavingSVG />
    </div>
  );
};

export default Project;